export class DpomApproveRequest {
    coReqDetails: {
        purchaseOrderNumber: string,
        poLineItemNumber: number,
        itemNo: string,
        exFactory: number
    }[]

}